import React from "react"
import { ImgS } from "ui-seeker/core"
import { countryCodeFactory, translateCountryCode } from "ui-seeker/utils"
import i18n from "i18n"
import { intlLocale } from "i18n/config"

import { IMAGE } from 'app/@common/constants'

// Localized country name from a 2-letter region code via Intl.DisplayNames (follows the active
// i18n language). Falls back to ui-seeker's EN translateCountryCode for non-ISO/invalid codes.
const localizedCountryName = cc => {
    try {
        const name = new Intl.DisplayNames([intlLocale(i18n.language)], { type: 'region' }).of(cc)
        if (name && name !== cc) return name
    } catch (e) {
        // invalid region code (e.g. non-ISO) → fall back to the library mapping below
    }
    return translateCountryCode(cc)
}


const TmpFlag = ({ countryCode }) => {

    const img = countryCode === 'GLOBE' ? `${IMAGE.ASSETS}/flags/globe.png` : `${IMAGE.ASSETS}/flags/${countryCode.toLowerCase()}.svg`

    return <abbr style={{ display: 'inline-block', verticalAlign: 'middle', width: '20px', textAlign: 'center', lineHeight: '0', marginRight: '5px' }}>
        <ImgS src={img} alt={`Flag of ${countryCode}`} style={{ display: "inline-block", height: "1em", verticalAlign: "middle", maxWidth: '100%' }} />
    </abbr>
}

const TmpCountryText = ({ countryText, label }) =>
    <abbr style={{ display: 'inline-block', verticalAlign: 'middle' }}>{` ${countryText}`} {label}</abbr>

// withIsoCode: with countryName, appends the ISO code in grey — "México (MX)".
export const formatWithFlag = (countryCode, { label='', countryName=false, isoCode=false, withIsoCode=false } = {}) => {
    const cc = (countryCode === "COM" || countryCode === "None") ? "GLOBE" : countryCodeFactory(countryCode)
    if (cc === null) return ''

    const countryText = isoCode ? (cc === "GLOBE" ? "COM" : cc)
        : countryName ? (cc === "GLOBE" ? "COM" : localizedCountryName(cc))
        : ''
    const isoLabel = withIsoCode && countryName && !isoCode && cc !== "GLOBE"
        ? <span style={{ color: '#999', fontSize: '0.85em' }}>({cc})</span>
        : null

    return <>
        <TmpFlag countryCode={cc} /> <TmpCountryText countryText={countryText} label={<>{isoLabel}{label}</>} />
    </>
}

const normalizeSearch = text => String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

// react-select filterOption for country options rendered with formatWithFlag: matches the localized name the
// user sees (accent/case insensitive), plus the backend label and the ISO code.
export const filterCountryOption = (option, input) => {
    const term = normalizeSearch(input).trim()
    if (!term) return true
    const cc = (option.value === "COM" || option.value === "None") ? null : countryCodeFactory(option.value)
    const name = cc ? localizedCountryName(cc) : ''
    return [name, option.label, option.value].some(text => normalizeSearch(text).includes(term))
}